import DropCvFlow from "./DropCvFlow";

function DropCv({ open, onClose, companyId, onSubmitted }) {
  return (
    <DropCvFlow
      open={open}
      onClose={onClose}
      companyId={companyId}
      onSubmitted={onSubmitted}
      signupSource="company-profile"
    />
  );
}

export default DropCv;
